export default __webpack_public_path__ + "static/media/logo.4ff1c909.png";